import type { GetStaticProps } from 'next'

import { NewtClient } from '@/utils/NewtClient'

import type { MediaKit } from '@/types/mediaKit'

export { MediaPage as default } from '@/components/pages/News/Media'

export const getStaticProps: GetStaticProps = async () => {
  const client = new NewtClient()
  const mediaKit = await client.fetchMediaKit()

  const mediaKitMap = new Map<string, { order: number; data: MediaKit[] }>()
  mediaKit.forEach((item) => {
    const { title, order } = item.media

    if (mediaKitMap.has(title)) {
      mediaKitMap.get(title)?.data.push(item)
    } else {
      mediaKitMap.set(title, { order, data: [item] })
    }
  })

  const sortedMediaKit = Array.from(mediaKitMap).sort(
    (a, b) => a[1].order - b[1].order
  )

  return {
    props: {
      mediaKit: sortedMediaKit,
    },
  }
}
